import api from "../../../../conf/api";
import { fetchEditorTemplate } from "../../components/EditorTemplateGallery";

/**
 * Request caches for one batch-editor session: 30 tabs on one template fetch
 * it once, and each WGID's raw clips are listed once. A failed request is
 * forgotten, so opening the tab again retries it.
 */
export function createBatchCaches() {
  const templates = new Map();
  const rawLists = new Map();

  const cached = (map, key, load) => {
    if (!map.has(key)) {
      const p = load().catch((err) => {
        map.delete(key);
        throw err;
      });
      map.set(key, p);
    }
    return map.get(key);
  };

  return {
    /** Template detail `{id, name, version, document}`, as fetchEditorTemplate. */
    fetchTemplate: (id) => cached(templates, String(id), () => fetchEditorTemplate(id)),
    /** A WGID's raw clips `[{id, url, ...}]`, in Admin Portal's order. */
    rawVideos: (wgid) =>
      cached(rawLists, wgid, () =>
        api
          .get(`/mrss/raw-videos/${encodeURIComponent(wgid)}/`)
          .then((res) => (Array.isArray(res.data?.raw_videos) ? res.data.raw_videos : [])),
      ),
  };
}
